// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".msgitem[data-v-7ab6407a] {\n  padding: 0 20px;\n}\n.numstyle[data-v-7ab6407a] {\n  background-color: #DE614C;\n  height: 16px;\n  min-width: 16px;\n  padding: 0 3px;\n  font-size: 12px;\n  border-radius: 10px;\n  color: #fff;\n  text-align: center;\n  line-height: 16px;\n  margin-left: 15px;\n}\n.msgicon[data-v-7ab6407a] {\n  height: 20px;\n  width: auto;\n}\n.msgtime[data-v-7ab6407a] {\n  color: #BFC1C2;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
